import { render, staticRenderFns } from "./langhamConnected.vue?vue&type=template&id=b0523148&scoped=true&"
import script from "./langhamConnected.vue?vue&type=script&lang=js&"
export * from "./langhamConnected.vue?vue&type=script&lang=js&"
import style0 from "./langhamConnected.vue?vue&type=style&index=0&id=b0523148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0523148",
  null
  
)

export default component.exports